// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"ec","pgUseBox":"ec","use-card-wrap":"ed","useCardWrap":"ed","use-box-wrap":"ee","useBoxWrap":"ee"};